<template>
  <div class="card mb-25 border-0 rounded-0 bg-white add-besc-card shadow-sm">
    <!-- Step Progress Tracker -->
    <StepProgressTracker :current-step="'step1'" :besc-id="bescId" />

    <div class="card-header d-flex justify-content-between align-items-center py-4 px-4"
      style="background-color: #0a59a4;">
      <div>
        <h3 class="text-white fw-bold mb-1">Étape 1/4 – Informations de base du BESC</h3>
        <small class="text-white opacity-75">Remplissez les informations générales du bordereau</small>
      </div>
    </div>

    <div class="card-body p-15 p-sm-20 p-md-30 letter-spacing">
      <div v-if="loadingBesc" class="text-center py-5">
        <div class="spinner-border text-primary" role="status">
          <span class="visually-hidden">Chargement...</span>
        </div>
        <p class="mt-3 text-muted">Chargement des données...</p>
      </div>

      <Form :initial-values="form" :validation-schema="schema" @submit="saveStep1">
        <div class="section-title mb-4">
          <h5 class="text-primary fw-bold border-bottom pb-2">Parties prenantes</h5>
        </div>
        <div class="row g-3 mb-4">

          <div class="col-md-4">
            <div class="d-flex justify-content-between align-items-center mb-2">
              <label class="text-black fw-semibold mb-0"> Importateur / Destinataire
                <span class="text-danger">*</span>
              </label>
              <a href="#" class="btn btn-primary btn-sm" @click.prevent="openActeurModal('importateur', 'Importateur')"
                title="Ajouter un nouvel importeur">
                <i class="flaticon-plus"></i>
              </a>
            </div>
            <Field name="importateur" v-slot="{ field, setValue }">
              <Multiselect 
                :model-value="field.value" 
                @update:model-value="async (val) => {
                  setValue(val);
                  const acteur = acteursParType.importateur.find(a => a.value === val);
                  if (acteur?.refActeur) {
                    const result = await checkBlacklist('PERSON', acteur.refActeur);
                    blacklistAlerts.importateur = result.isBlacklisted ? result.details : null;
                  } else {
                    blacklistAlerts.importateur = null;
                  }
                }"
                :options="acteursParType.importateur" :searchable="true" :loading="loadingActeurs"
                placeholder="Rechercher un importateur..." label="label" track-by="value" />
            </Field>
          </div>

          <div class="col-md-4">
            <div class="d-flex justify-content-between align-items-center mb-2">
              <label class="text-black fw-semibold mb-0"> Partie à notifier
                <span class="text-danger">*</span>
              </label>
              <a href="#" class="btn btn-primary btn-sm"
                @click.prevent="openActeurModal('partieANotifier', 'Partie à notifier')"
                title="Ajouter une partie à notifier">
                <i class="flaticon-plus"></i>
              </a>
            </div>
            <Field name="partieANotifier" v-slot="{ field, setValue }">
              <Multiselect 
                :model-value="field.value" 
                @update:model-value="async (val) => {
                  setValue(val);
                  const acteur = acteursParType.partie_a_notifier.find(a => a.value === val);
                  if (acteur?.refActeur) {
                    const result = await checkBlacklist('PERSON', acteur.refActeur);
                    blacklistAlerts.partieANotifier = result.isBlacklisted ? result.details : null;
                  } else {
                    blacklistAlerts.partieANotifier = null;
                  }
                }"
                :options="acteursParType.partie_a_notifier" :searchable="true" :loading="loadingActeurs"
                placeholder="Rechercher une partie..." label="label" track-by="value" />
            </Field>
          </div>

          <!-- <div class="col-md-4">
            <div class="d-flex justify-content-between align-items-center mb-2">
              <label class="text-black fw-semibold mb-0"> Transitaire
                <span class="text-danger">*</span>
              </label>
              <a href="#" class="btn btn-primary btn-sm" @click.prevent="openActeurModal('transitaire', 'Transitaire')"
                title="Ajouter un nouvel transitaire">
                <i class="flaticon-plus"></i>
              </a>
            </div>
            <Field name="transitaire" v-slot="{ field, setValue }">
              <Multiselect 
                :model-value="field.value" 
                @update:model-value="async (val) => {
                  setValue(val);
                  const acteur = acteursParType.transitaire.find(a => a.value === val);
                  if (acteur?.refActeur) {
                    const result = await checkBlacklist('PERSON', acteur.refActeur);
                    blacklistAlerts.transitaire = result.isBlacklisted ? result.details : null;
                  } else {
                    blacklistAlerts.transitaire = null;
                  }
                }"
                :options="acteursParType.transitaire" 
                :searchable="true" 
                :loading="loadingActeurs"
                :disabled="isTransitaire"
                :class="{ 'bg-light': isTransitaire }"
                placeholder="Rechercher un transitaire..." 
                label="label" 
                track-by="value" />
            </Field>
          </div> -->
            <div class="col-md-4">
              <label class="d-block text-black fw-semibold mb-2">
                Transitaire <span class="text-danger">*</span>
              </label>

              <Field name="transitaire" v-slot="{ field }">
                <input 
                  v-if="isTransitaire"
                  type="text" 
                  class="form-control shadow-sm bg-light text-muted" 
                  :disabled="true"
                  :value="transitaireNom"
                />
                
                <Multiselect
                  v-else
                  :model-value="field.value"
                  @update:model-value="(val) => field.onChange(val)"
                  :options="usersTransitaires"
                  :searchable="true"
                  :loading="loadingTransitaires"
                  placeholder="Rechercher un transitaire..."
                  label="label"
                  track-by="value"
                />
              </Field>

              <ErrorMessage name="transitaire" class="text-danger d-block mt-1" />
            </div>

          

          <div class="col-md-4">
            <div class="d-flex justify-content-between align-items-center mb-2">
              <label class="text-black fw-semibold mb-0"> Expéditeur
                <span class="text-danger">*</span>
              </label>
              <a href="#" class="btn btn-primary btn-sm" @click.prevent="openActeurModal('expediteur', 'Expediteur')"
                title="Ajouter un nouvel expediteur">
                <i class="flaticon-plus"></i>
              </a>
            </div>
            <Field name="expediteur" v-slot="{ field, setValue }">
              <Multiselect 
                :model-value="field.value" 
                @update:model-value="async (val) => {
                  setValue(val);
                  const acteur = acteursParType.expediteur.find(a => a.value === val);
                  if (acteur?.refActeur) {
                    const result = await checkBlacklist('PERSON', acteur.refActeur);
                    blacklistAlerts.expediteur = result.isBlacklisted ? result.details : null;
                  } else {
                    blacklistAlerts.expediteur = null;
                  }
                }"
                :options="acteursParType.expediteur" :searchable="true" :loading="loadingActeurs"
                placeholder="Rechercher un expediteur..." label="label" track-by="value" />
            </Field>
          </div>

          <div class="col-md-4">
            <div class="d-flex justify-content-between align-items-center mb-2">
              <label class="text-black fw-semibold mb-0"> Incoterm </label>
              <span></span>
            </div>
            <Field name="incoterm" v-slot="{ field, setValue, errorMessage }">
              <Multiselect :model-value="field.value" @update:model-value="setValue" :options="incoterms"
                placeholder="Sélectionner" label="label" track-by="value" />
              <small v-if="errorMessage" class="text-danger d-block mt-1">{{ errorMessage }}</small>
            </Field>
          </div>

          <div class="col-md-4">
            <label class="d-block text-black fw-semibold mb-2">
              Pays d'origine <span class="text-danger">*</span>
            </label>
            <Field name="paysOrigine" v-slot="{ field, setValue, errorMessage }">
              <Multiselect 
                :model-value="field.value" 
                @update:model-value="async (val) => { 
                  form.paysOrigine = val; 
                  setValue(val);           
                  onPaysOrigineChange();
                  const paysObj = paysAvecCodes.find(p => p.value === val);
                  if (paysObj?.iso2_code) {
                    const result = await checkBlacklist('COUNTRY', paysObj.iso2_code);
                    blacklistAlerts.paysOrigine = result.isBlacklisted ? result.details : null;
                  } else {
                    blacklistAlerts.paysOrigine = null;
                  }
                }" 
                :options="pays" 
                :searchable="true"
                :filter-results="true"
                value-prop="value"
                label="label"
                :resolve-on-load="false"
                placeholder="Rechercher..." 
              />
              <small v-if="errorMessage" class="text-danger d-block mt-1">{{ errorMessage }}</small>
            </Field>
          </div>

          <div class="col-md-4">
            <label class="d-block text-black fw-semibold mb-2">
              Paiement du fret <span class="text-danger">*</span>
            </label>
            <Field name="typeFret" v-slot="{ field, setValue, errorMessage }">
              <Multiselect :model-value="field.value" @update:model-value="setValue" :options="paiementFret"
                :loading="loading" placeholder="Sélectionner" label="label" track-by="value" />
              <small v-if="errorMessage" class="text-danger d-block mt-1">{{ errorMessage }}</small>
            </Field>
          </div>

          <div class="col-md-4">
            <label class="d-block text-black fw-semibold mb-2">
              Numéro de BL / Connaissement <span class="text-danger">*</span>
            </label>
            <Field name="numeroConnaissement" type="text" class="form-control shadow-sm"
              placeholder="ex: MSCU123456789" />
            <ErrorMessage name="numeroConnaissement" class="text-danger d-block mt-1" />
          </div>

          <!-- Alerte globale pour les parties prenantes -->
          <div class="col-md-12" v-if="blacklistAlerts.importateur || blacklistAlerts.partieANotifier || blacklistAlerts.transitaire || blacklistAlerts.expediteur">
            <div class="alert alert-danger text-center py-3 px-4 mt-3">
              <h6 class="fw-bold mb-3">
                <i class="ph-warning-circle fs-4"></i>ALERTE BLACKLIST - PARTIES PRENANTES
              </h6>
              <div class="text-start">
                <ul class="mb-0">
                  <li v-if="blacklistAlerts.importateur" class="mb-2">
                    <strong>Importateur:</strong> Liste {{ blacklistAlerts.importateur.list_code }} - {{ blacklistAlerts.importateur.reason }}
                  </li>
                  <li v-if="blacklistAlerts.partieANotifier" class="mb-2">
                    <strong>Partie à notifier:</strong> Liste {{ blacklistAlerts.partieANotifier.list_code }} - {{ blacklistAlerts.partieANotifier.reason }}
                  </li>
                  <li v-if="blacklistAlerts.transitaire" class="mb-2">
                    <strong>Transitaire:</strong> Liste {{ blacklistAlerts.transitaire.list_code }} - {{ blacklistAlerts.transitaire.reason }}
                  </li>
                  <li v-if="blacklistAlerts.expediteur" class="mb-2">
                    <strong>Expéditeur:</strong> Liste {{ blacklistAlerts.expediteur.list_code }} - {{ blacklistAlerts.expediteur.reason }}
                  </li>
                </ul>
              </div>
            </div>
          </div>

        </div>

        <div class="section-title mb-4 mt-5">
          <h5 class="text-primary fw-bold border-bottom pb-2">Informations transport & itinéraire</h5>
        </div>
        <div class="row g-3 mb-4">

          <div class="col-md-4">
            <div class="d-flex justify-content-between align-items-center mb-2">
              <label class="text-black fw-semibold mb-0"> Transporteur
                <span class="text-danger">*</span>
              </label>
              <a href="#" class="btn btn-primary btn-sm"
                @click.prevent="openActeurModal('transporteur', 'Transporteur')" title="Ajouter un nouvel transporteur">
                <i class="flaticon-plus"></i>
              </a>
            </div>
            <Field name="transporteur" v-slot="{ field, setValue }">
              <Multiselect 
                :model-value="field.value" 
                @update:model-value="async (val) => {
                  setValue(val);
                  const acteur = acteursParType.transporteur.find(a => a.value === val);
                  if (acteur?.refActeur) {
                    const result = await checkBlacklist('PERSON', acteur.refActeur);
                    blacklistAlerts.transporteur = result.isBlacklisted ? result.details : null;
                  } else {
                    blacklistAlerts.transporteur = null;
                  }
                }"
                :options="acteursParType.transporteur" :searchable="true" :loading="loadingActeurs"
                placeholder="Rechercher un transporteur..." label="label" track-by="value" />
            </Field>
          </div>

          <div class="col-md-4">
            <label class="d-block text-black fw-semibold mb-2">Navire</label>
            <Field name="vessel" v-slot="{ field, setValue }" :key="vesselKey">
              <Multiselect 
                :model-value="field.value" 
                @update:model-value="async (val) => {
                  setValue(val?.value || val);
                  const navire = navires.find(n => n.value === (val?.value || val));
                  if (navire?.imo) {
                    const result = await checkBlacklist('SHIP', navire.imo);
                    blacklistAlerts.vessel = result.isBlacklisted ? result.details : null;
                  } else {
                    blacklistAlerts.vessel = null;
                  }
                }"
                :options="navires" :searchable="true" :loading="loadingNavires"
                placeholder="Rechercher (IMO ou MMSI)..." label="label" track-by="value"
                @search-change="(query) => searchNavire(query, field.value)" :filter-results="false" :min-chars="2" />
            </Field>
          </div>

          <div class="col-md-4">
            <label class="d-block text-black fw-semibold mb-2">Transbordement</label>
            <Field name="transbordement" v-slot="{ field, setValue }">
              <div class="d-flex gap-3">
                <div class="form-check">
                  <input class="form-check-input" type="radio" :value="'oui'" :checked="field.value === 'oui'"
                    @change="() => { setValue('oui'); showTransbordementFields = true }" id="transbordementOui">
                  <label class="form-check-label" for="transbordementOui">
                    Oui
                  </label>
                </div>
                <div class="form-check">
                  <input class="form-check-input" type="radio" :value="'non'" :checked="field.value === 'non'"
                    @change="() => { setValue('non'); showTransbordementFields = false }" id="transbordementNon">
                  <label class="form-check-label" for="transbordementNon">
                    Non
                  </label>
                </div>
              </div>
            </Field>
          </div>

          <div class="col-md-4" v-if="showTransbordementFields">
            <label class="d-block text-black fw-semibold mb-2">Navire après transbordement</label>
            <Field name="navireApresTransbordement" v-slot="{ field, setValue }">
              <Multiselect :model-value="field.value" @update:model-value="(val) => setValue(val?.value || val)"
                :options="navires" :searchable="true" :loading="loadingNavires"
                placeholder="Rechercher (IMO ou MMSI)..." label="label" track-by="value" @search-change="searchNavire"
                :filter-results="false" :min-chars="2" />
            </Field>
          </div>

          <div class="col-md-4" v-if="showTransbordementFields">
            <div class="d-flex justify-content-between align-items-center mb-2">
              <label class="text-black fw-semibold mb-0"> Transporteur après transbordement
                <span class="text-danger">*</span>
              </label>
              <a href="#" class="btn btn-primary btn-sm"
                @click.prevent="openActeurModal('transporteurApresTransbordement', 'Après transbordement')"
                title="Ajouter un nouvel transporteur après transbordement">
                <i class="flaticon-plus"></i>
              </a>
            </div>
            <Field name="transporteurApresTransbordement" v-slot="{ field, setValue }">
              <Multiselect :model-value="field.value" @update:model-value="setValue"
                :options="acteursParType.transporteurApresTransbordement" :searchable="true" :loading="loadingActeurs"
                placeholder="Rechercher un transporteurApresTransbordement..." label="label" track-by="value" />
            </Field>
          </div>

          <div class="col-md-4">
            <label class="d-block text-black fw-semibold mb-2">
              Port de chargement <span class="text-danger">*</span>
            </label>
            <Field name="portChargement" v-slot="{ field, setValue }">
              <Multiselect 
                :model-value="field.value" 
                @update:model-value="async (val) => {
                  setValue(val?.value || val);
                  const port = portsChargement.find(p => p.value === (val?.value || val));
                  if (port?.locode) {
                    const result = await checkBlacklist('PORT', port.locode);
                    blacklistAlerts.portChargement = result.isBlacklisted ? result.details : null;
                  } else {
                    blacklistAlerts.portChargement = null;
                  }
                }"
                :options="portsChargementFiltres" :searchable="true" :loading="loadingPorts"
                placeholder="Tapez pour rechercher un port..." label="label" track-by="value"
                @search-change="searchPortChargement" :filter-results="false" :min-chars="2"
                no-options-text="Commencez à taper pour rechercher le port du pays d'origine"
                no-results-text="Aucun port trouvé" />
            </Field>
            <small v-if="!form.paysOrigine" class="text-muted">
              Sélectionnez d'abord un pays d'origine
            </small>
          </div>

          <div class="col-md-4">
            <label class="d-block text-black fw-semibold mb-2">
              Destination finale <span class="text-danger">*</span>
            </label>
            <Field name="destinationFinale" v-slot="{ field, setValue }">
              <Multiselect 
                :model-value="field.value" 
                @update:model-value="async (val) => {
                  form.destinationFinale = val;
                  setValue(val);
                  onPaysDestinationChange();
                  const paysObj = paysAvecCodes.find(p => p.value === val);
                  if (paysObj?.iso2_code) {
                    const result = await checkBlacklist('COUNTRY', paysObj.iso2_code);
                    blacklistAlerts.destinationFinale = result.isBlacklisted ? result.details : null;
                  } else {
                    blacklistAlerts.destinationFinale = null;
                  }
                }" 
                :options="pays" 
                :searchable="true"
                :filter-results="true"
                value-prop="value"
                label="label"
                :resolve-on-load="false"
                :loading="loading" 
                placeholder="Rechercher..." 
              />
            </Field>
          </div>
          <div class="col-md-4">
            <label class="d-block text-black fw-semibold mb-2">
              Port de déchargement <span class="text-danger">*</span>
            </label>
            <Field name="portDechargement" v-slot="{ field, setValue }">
              <Multiselect 
                :model-value="field.value" 
                @update:model-value="async (val) => {
                  setValue(val?.value || val);
                  const port = portsDechargement.find(p => p.value === (val?.value || val));
                  if (port?.locode) {
                    const result = await checkBlacklist('PORT', port.locode);
                    blacklistAlerts.portDechargement = result.isBlacklisted ? result.details : null;
                  } else {
                    blacklistAlerts.portDechargement = null;
                  }
                }"
                :options="portsDechargementFiltres" :searchable="true" :loading="loadingPorts"
                placeholder="Rechercher (nomPort ou locode)..." label="label" track-by="value"
                @search-change="searchPortDechargement" :filter-results="false" :min-chars="2"
                no-options-text="Commencez à taper pour rechercher le port du pays de destination"
                no-results-text="Aucun port trouvé" />
              <ErrorMessage name="portDechargement" class="text-danger d-block mt-1" />
            </Field>
            <small v-if="!form.destinationFinale" class="text-muted">
              Sélectionnez d'abord une destination finale
            </small>
          </div>

          <div class="col-md-4">
            <label class="d-block text-black fw-semibold mb-2">
              ETD (Date de Départ estimé) <span class="text-danger">*</span>
            </label>
            <Field name="etd" type="date" class="form-control shadow-sm" :min="today" />
            <ErrorMessage name="etd" class="text-danger d-block mt-1" />
          </div>

          <div class="col-md-4">
            <label class="d-block text-black fw-semibold mb-2">
              ETA (Date d'Arrivée estimée) <span class="text-danger">*</span>
            </label>
            <Field name="eta" type="date" class="form-control shadow-sm" :min="form.etd || today" />
            <ErrorMessage name="eta" class="text-danger d-block mt-1" />
          </div>

          <!-- Alerte globale pour transport & itinéraire -->
          <div class="col-md-12" v-if="blacklistAlerts.transporteur || blacklistAlerts.vessel || blacklistAlerts.navireApresTransbordement || blacklistAlerts.portChargement || blacklistAlerts.portDechargement || blacklistAlerts.destinationFinale">
            <div class="alert alert-danger text-center py-3 px-4 mt-3">
              <h6 class="fw-bold mb-3">
                <i class="ph-warning-circle fs-4"></i> ALERTE BLACKLIST - TRANSPORT & ITINÉRAIRE
              </h6>
              <div class="text-start">
                <ul class="mb-0">
                  <li v-if="blacklistAlerts.transporteur" class="mb-2">
                    <strong>Transporteur:</strong> Liste {{ blacklistAlerts.transporteur.list_code }} - {{ blacklistAlerts.transporteur.reason }}
                  </li>
                  <li v-if="blacklistAlerts.vessel" class="mb-2">
                    <strong>Navire:</strong> Liste {{ blacklistAlerts.vessel.list_code }} - {{ blacklistAlerts.vessel.reason }}
                  </li>
                  <li v-if="blacklistAlerts.navireApresTransbordement" class="mb-2">
                    <strong>Navire après transbordement:</strong> Liste {{ blacklistAlerts.navireApresTransbordement.list_code }} - {{ blacklistAlerts.navireApresTransbordement.reason }}
                  </li>
                  <li v-if="blacklistAlerts.portChargement" class="mb-2">
                    <strong>Port de chargement:</strong> Liste {{ blacklistAlerts.portChargement.list_code }} - {{ blacklistAlerts.portChargement.reason }}
                  </li>
                  <li v-if="blacklistAlerts.portDechargement" class="mb-2">
                    <strong>Port de déchargement:</strong> Liste {{ blacklistAlerts.portDechargement.list_code }} - {{ blacklistAlerts.portDechargement.reason }}
                  </li>
                  <li v-if="blacklistAlerts.destinationFinale" class="mb-2">
                    <strong>Destination finale:</strong> Liste {{ blacklistAlerts.destinationFinale.list_code }} - {{ blacklistAlerts.destinationFinale.reason }}
                  </li>
                </ul>
              </div>
            </div>
          </div>

        </div>

        <!-- BOUTONS -->
        <div class="d-flex justify-content-between align-items-center mt-5 pt-4 border-top">
          <router-link to="/liste-besc" class="btn btn-danger px-4">Annuler</router-link>

          <div class="d-flex gap-3">
            <button type="submit" class="btn btn-primary px-5 py-2 text-white" :disabled="loading">
              {{ loading
                ? 'Enregistrement...'
                : isEditMode
                  ? 'Mettre à jour & Continuer (Étape 2/4)'
                  : 'Valider & Continuer (Étape 2/4)'
              }}
            </button>

          </div>
        </div>

      </Form>
    </div>

    <ActeurModal :key="currentTypeActeurId" v-model="showActeurModal" :field-to-fill="currentActeurField"
      :type-acteur-id="currentTypeActeurId" @created="onActeurCreated" />

  </div>
</template>

<script lang="ts">
import { defineComponent, ref, reactive, onMounted, watch, computed, nextTick } from 'vue'
import { Form, Field, ErrorMessage, useForm } from 'vee-validate'
import Multiselect from '@vueform/multiselect'
import * as Yup from 'yup'
import ApiService from '@/services/ApiService'
import { success, error, warning } from '@/utils/utils'
import { bescWizard, resetBescWizard, updateStepProgression, loadBescProgressionFromAPI } from '@/utils/bescWizard'
import { useRouter, useRoute } from 'vue-router'
import ActeurModal from './ActeurModal.vue'
import StepProgressTracker from '@/components/BESC/StepProgressTracker.vue'
import { Besc } from '@/models/Besc'
import { useAuthStore, User } from "@/services/auth"
import JwtService from "@/services/JwtService"

export default defineComponent({
  name: 'AddBescStep1',
  components: {
    Form,
    Field,
    ErrorMessage,
    Multiselect,
    ActeurModal,
    StepProgressTracker
  },

  setup() {
    const router = useRouter()
    const route = useRoute()
    const bescId = ref<string>(route.params.id as string || '')
    const loading = ref(false)
    const loadingBesc = ref(false)
    const loadingActeurs = ref(false)
    const loadingPorts = ref(false)
    const today = new Date().toISOString().split('T')[0]
    const showActeurModal = ref(false)
    const currentActeurField = ref<string | undefined>(undefined)
    const form = bescWizard.step1
    
    const currentUser = JwtService.getUser()
      console.log('currentUser depuis JWT:', currentUser)
    const roles = ref<Array<string>>(JwtService.getRole())
    const checkRole = (name: string) => roles.value.includes(name)
    const isTransitaire = computed(() => checkRole('Transitaire'))
    // const currentUserId = computed(() => store.user?.id)
      const blacklistAlerts = ref<{
      importateur: any;
      expediteur: any;
      transitaire: any;
      transporteur: any;
      partieANotifier: any;
      paysOrigine: any;
      destinationFinale: any;
      portChargement: any;
      portDechargement: any;
      vessel: any;
      navireApresTransbordement: any;
    }>({
      importateur: null,
      expediteur: null,
      transitaire: null,
      transporteur: null,
      partieANotifier: null,
      paysOrigine: null,
      destinationFinale: null,
      portChargement: null,
      portDechargement: null,
      vessel: null,
      navireApresTransbordement: null
    })

    const usersTransitaires = ref<Array<{ label: string; value: number }>>([])
    const loadingTransitaires = ref(false)
    const transitaireNom = ref('')



    const showTransbordementFields = ref(false)
    const { setFieldValue } = useForm()
    const vesselKey = ref(0)

    const transbordementOptions = ref([
      { label: 'Oui', value: 'oui' },
      { label: 'Non', value: 'non' }
    ])

    const incoterms = ref([])
    const pays = ref([])
    const paiementFret = ref([])
    const navires = ref<Array<{ label: string; value: number; imo?: string }>>([])
    const ports = ref<Array<{ label: string; value: number }>>([])
    const acteurs = ref<Array<{ label: string; value: number; refActeur?: string }>>([])
    const typeActeurs = ref<Map<string, string>>(new Map())
    const acteursParType = ref<Record<string, any[]>>({})
    const loadingNavires = ref(false)
    let searchTimeout: ReturnType<typeof setTimeout> | null = null
    const isEditMode = computed(() => !!bescWizard.bescId)
    const portsChargement = ref<Array<{ label: string; value: number; codePays: string; locode?: string }>>([])
    const portsDechargement = ref<Array<{ label: string; value: number; codePays: string; locode?: string }>>([])
    const paysAvecCodes = ref<Array<{ label: string; value: number; iso2_code: string }>>([])



    const schema = Yup.object({
      importateur: Yup.string().required('Importateur requis'),
      partieANotifier: Yup.string().required('Partie à notifier requise'),
      transitaire: Yup.string().when([], {
        is: () => !isTransitaire.value,
        then: (schema) => schema.required('Transitaire requis'),
        otherwise: (schema) => schema.notRequired()
      }),
      expediteur: Yup.string().required('Expéditeur requis'),
      transporteur: Yup.string().required('Transporteur requis'),
      numeroConnaissement: Yup.string().required('Numéro BL requis'),
      typeFret: Yup.string().required('Paiement du fret requis'),
      portChargement: Yup.string().required('Port de chargement requis'),
      portDechargement: Yup.string().required('Port de déchargement requis'),
      paysOrigine: Yup.string().required('Pays d\'origine requis'),
      destinationFinale: Yup.string().required('Destination finale requise'),
      transbordement: Yup.string().required('Transbordement requis'),
      etd: Yup.date().required('ETD requis'),
      eta: Yup.date()
        .required('ETA requis')
        .min(Yup.ref('etd'), 'ETA doit être ≥ ETD'),

      navireApresTransbordement: Yup.string().when('transbordement', {
        is: 'oui',
        then: (schema) => schema.required('Navire après transbordement requis'),
        otherwise: (schema) => schema.nullable()
      }),
      transporteurApresTransbordement: Yup.string().when('transbordement', {
        is: 'oui',
        then: (schema) => schema.required('Transporteur après transbordement requis'),
        otherwise: (schema) => schema.nullable()
      })
    })

    const fetchBescData = async (id: string) => {
      console.log('fetchBescData appelée avec ID:', id)
      loadingBesc.value = true
      try {
        const response = await ApiService.get(`/besc/${id}`)
        const bescData = response.data.data

        if (bescData.importateur) {
          form.importateur = bescData.importateur
          setFieldValue('importateur', bescData.importateur)
        }
        if (bescData.partieANotifier) {
          form.partieANotifier = bescData.partieANotifier
          setFieldValue('partieANotifier', bescData.partieANotifier)
        }
        if (bescData.transitaire) {
          form.transitaire = bescData.transitaire
          setFieldValue('transitaire', bescData.transitaire)
        }
        if (bescData.expediteur) {
          form.expediteur = bescData.expediteur
          setFieldValue('expediteur', bescData.expediteur)
        }
        if (bescData.transporteur) {
          form.transporteur = bescData.transporteur
          setFieldValue('transporteur', bescData.transporteur)
        }

        // Charger les autres champs
        if (bescData.numeroConnaissement) {
          form.numeroConnaissement = bescData.numeroConnaissement
          setFieldValue('numeroConnaissement', bescData.numeroConnaissement)
        }
        if (bescData.incoterm) {
          form.incoterm = bescData.incoterm
          setFieldValue('incoterm', bescData.incoterm)
        }
        if (bescData.paysOrigine) {
          form.paysOrigine = bescData.paysOrigine
          setFieldValue('paysOrigine', bescData.paysOrigine)
        }
        if (bescData.typeFret) {
          form.typeFret = bescData.typeFret
          setFieldValue('typeFret', bescData.typeFret)
        }
        if (bescData.destinationFinale) {
          form.destinationFinale = bescData.destinationFinale
          setFieldValue('destinationFinale', bescData.destinationFinale)
        }
        if (bescData.transbordement) {
          form.transbordement = bescData.transbordement
          setFieldValue('transbordement', bescData.transbordement)
        }
        if (bescData.transporteurApresTransbordement) {
          form.transporteurApresTransbordement = bescData.transporteurApresTransbordement
          setFieldValue('transporteurApresTransbordement', bescData.transporteurApresTransbordement)
        }
        if (bescData.etd) {
          const etdFormatted = bescData.etd.split('T')[0]
          form.etd = etdFormatted
          setFieldValue('etd', etdFormatted)
        }
        if (bescData.eta) {
          const etaFormatted = bescData.eta.split('T')[0]
          form.eta = etaFormatted
          setFieldValue('eta', etaFormatted)
        }

        // NAVIRE PRINCIPAL
        if (bescData.vessel?.id) {
          const vesselOption = {
            label: `${bescData.vessel.name} - ${bescData.vessel.mmsi || 'N/A'} - ${bescData.vessel.imo || 'N/A'}`,
            value: bescData.vessel.id
          }
          if (!navires.value.find(n => n.value === bescData.vessel.id)) {
            navires.value.push(vesselOption)
            console.log('Navire principal ajouté:', vesselOption.label)
          }
          form.vessel = bescData.vessel.id
          setFieldValue('vessel', bescData.vessel.id)
        }

        if (bescData.navireApresTransbordement?.id) {
          const vesselOption = {
            label: `${bescData.navireApresTransbordement.name} - ${bescData.navireApresTransbordement.mmsi || 'N/A'} - ${bescData.navireApresTransbordement.imo || 'N/A'}`,
            value: bescData.navireApresTransbordement.id
          }
          if (!navires.value.find(n => n.value === bescData.navireApresTransbordement.id)) {
            navires.value.push(vesselOption)
            console.log('Navire après transbordement ajouté:', vesselOption.label)
          }
          form.navireApresTransbordement = bescData.navireApresTransbordement.id
          setFieldValue('navireApresTransbordement', bescData.navireApresTransbordement.id)
        }

        // PORT DE CHARGEMENT
        if (bescData.portChargement?.id) {
          const portOption = {
            label: `${bescData.portChargement.nomPort} - ${bescData.portChargement.locode || 'N/A'}`,
            value: bescData.portChargement.id,
            codePays: bescData.portChargement.codePays || ''
          }
          if (!portsChargement.value.find(p => p.value === bescData.portChargement.id)) {
            portsChargement.value.push(portOption)
            console.log(' Port de chargement ajouté:', portOption.label)
          }
          form.portChargement = bescData.portChargement.id
          setFieldValue('portChargement', bescData.portChargement.id)
        }

        // PORT DE DÉCHARGEMENT
        if (bescData.portDechargement?.id) {
          const portOption = {
            label: `${bescData.portDechargement.nomPort} - ${bescData.portDechargement.locode || 'N/A'}`,
            value: bescData.portDechargement.id,
            codePays: bescData.portDechargement.codePays || ''
          }
          if (!portsDechargement.value.find(p => p.value === bescData.portDechargement.id)) {
            portsDechargement.value.push(portOption)
            console.log(' Port de déchargement ajouté:', portOption.label)
          }
          form.portDechargement = bescData.portDechargement.id
          setFieldValue('portDechargement', bescData.portDechargement.id)
        }

        if (bescData.transbordement === 'oui') {
          showTransbordementFields.value = true
        }

        await nextTick()

        if (bescData.vessel?.id) {
          setFieldValue('vessel', bescData.vessel.id)
        }
        if (bescData.portChargement?.id) {
          setFieldValue('portChargement', bescData.portChargement.id)
        }
        if (bescData.portDechargement?.id) {
          setFieldValue('portDechargement', bescData.portDechargement.id)
        }

        // Forcer le re-render du champ navire en changeant sa clé
        vesselKey.value++

        // Attendre encore un peu et forcer le navire une dernière fois
        setTimeout(() => {
          if (bescData.vessel?.id) {
            setFieldValue('vessel', bescData.vessel.id)
            console.log('Dernier setFieldValue pour vessel:', bescData.vessel.id)
          }
        }, 100)

        success('Données chargées avec succès !')
      } catch (err: any) {
        console.error('Erreur lors de la récupération du BESC:', err)
        error('Impossible de charger les données du BESC')
      } finally {
        loadingBesc.value = false
      }
    }

    const loadNavireOption = async (naviresId: string) => {
      try {
        const response = await ApiService.get(`/vessels/${naviresId}`)
        const navire = response.data.data

        const option = {
          label: `${navire.name} - ${navire.mmsi} - ${navire.imo}`,
          value: navire.id
        }

        if (!navires.value.find(n => n.value === navire.id)) {
          navires.value.push(option)
        }
      } catch (err) {
        console.error('Erreur chargement navire:', err)
      }
    }

    const loadPortOption = async (portId: string) => {
      try {
        const response = await ApiService.get(`/Liste/port/${portId}`)
        const port = response.data.data

        const option = {
          label: `${port.nomPort} - ${port.locode}`,
          value: port.id,
          codePays: port.codePays || ''
        }

        if (!portsChargement.value.find(p => p.value === port.id)) {
          portsChargement.value.push(option)
        }
        if (!portsDechargement.value.find(p => p.value === port.id)) {
          portsDechargement.value.push(option)
        }
      } catch (err) {
        console.error('Erreur chargement port:', err)
      }
    }

    const fetchTypeActeurs = async () => {
      try {
        const response = await ApiService.get('/typeActeurs')
        const typeActeursList = response.data.data.data

        typeActeursList.forEach((t: any) => {
          typeActeurs.value.set(t.libelle.toLowerCase(), t.id)
        })

        console.log("Types acteurs chargés:", typeActeurs.value)
      } catch (err) {
        error('Erreur chargement types acteurs')
      }
    }

    const fetchActeurs = async () => {
      loadingActeurs.value = true
      try {
        const { data } = await ApiService.get('/acteurs')
        const liste = data.data.data.map((a: any) => {
          return {
            label: a.nomComplet,
            value: a.id,
            typeId: a.typeActeur?.id,
            typeLibelle: a.typeActeur?.libelle,
            refActeur: a.refActeur
          }
        })

        acteursParType.value = {
          importateur: [],
          expediteur: [],
          partie_a_notifier: [],
          transporteur: [],
          transporteurApresTransbordement: []
        }

        liste.forEach((a: any) => {
          const libelle = a.typeLibelle?.toLowerCase()

          if (!libelle) {
            console.warn('Acteur SANS type:', a)
            return
          }

          if (libelle.includes('importateur')) {
            acteursParType.value.importateur.push(a)
          }
          if (libelle.includes('expéditeur') || libelle.includes('expediteur')) {
            acteursParType.value.expediteur.push(a)
          }
          if (libelle.includes('partie') || libelle.includes('notifier')) {
            acteursParType.value.partie_a_notifier.push(a)
          }
          if (libelle.includes('transporteur')) {
            acteursParType.value.transporteur.push(a)
            acteursParType.value.transporteurApresTransbordement.push(a)
          }
        })


        const acteursSpecifiques = sessionStorage.getItem('besc_acteurs_specifiques');
        if (acteursSpecifiques) {
          const acteurs = JSON.parse(acteursSpecifiques);
          console.log('Ajout des acteurs spécifiques aux listes:', acteurs);

          acteurs.forEach((acteur: any) => {
            const role = acteur.role;

            if (role.includes('importateur') && !acteursParType.value.importateur.find(a => a.value === acteur.value)) {
              acteursParType.value.importateur.push(acteur);
              console.log(' Importateur ajouté:', acteur.label);
            }
            if (role.includes('partie à notifier') && !acteursParType.value.partie_a_notifier.find(a => a.value === acteur.value)) {
              acteursParType.value.partie_a_notifier.push(acteur);
              console.log(' Partie à notifier ajoutée:', acteur.label);
            }

            if (role.includes('expediteur') && !acteursParType.value.expediteur.find(a => a.value === acteur.value)) {
              acteursParType.value.expediteur.push(acteur);
              console.log(' Expéditeur ajouté:', acteur.label);
              console.log('Importateur ajouté:', acteur.label);
            }
            if (role.includes('partie à notifier') && !acteursParType.value.partie_a_notifier.find(a => a.value === acteur.value)) {
              acteursParType.value.partie_a_notifier.push(acteur);
              console.log('Partie à notifier ajoutée:', acteur.label);
            }
            
            if (role.includes('expediteur') && !acteursParType.value.expediteur.find(a => a.value === acteur.value)) {
              acteursParType.value.expediteur.push(acteur);
              console.log('Expéditeur ajouté:', acteur.label);
            }
            if (role.includes('transporteur')) {
              if (!acteursParType.value.transporteur.find(a => a.value === acteur.value)) {
                acteursParType.value.transporteur.push(acteur);
                acteursParType.value.transporteurApresTransbordement.push(acteur);
                console.log('Transporteur ajouté:', acteur.label);
              }
            }
          });
          

          // Nettoyer le sessionStorage
          sessionStorage.removeItem('besc_acteurs_specifiques');
        }

      } catch (err: any) {
        console.error('ERREUR fetchActeurs:', err)
        error('Erreur chargement acteurs')
      } finally {
        loadingActeurs.value = false
      }
    }

    const currentTypeActeurId = ref<string>('')

    const openActeurModal = (fieldName: string, typeLibelle: string) => {
      const typeId = typeActeurs.value.get(typeLibelle.toLowerCase())

      if (!typeId) {
        warning(
          `Le type d'acteur "${typeLibelle}" n'existe pas encore dans le système. ` +
          `Veuillez d'abord créer ce type d'acteur dans la section de gestion des types avant de pouvoir ajouter des acteurs de ce type.`
        )
        return
      }
      currentActeurField.value = fieldName
      currentTypeActeurId.value = typeId
      showActeurModal.value = true
    }

    const onActeurCreated = ({ acteur, field }: { acteur: any; field: string | null }) => {
      if (!field) return

      const listes = {
        importateur: acteursParType.value.importateur,
        partieANotifier: acteursParType.value.partie_a_notifier,
        expediteur: acteursParType.value.expediteur,
        transporteur: acteursParType.value.transporteur,
        transporteurApresTransbordement: acteursParType.value.transporteurApresTransbordement
      }

      if (field in listes) {
        listes[field as keyof typeof listes].push(acteur)
      }

      form[field as keyof Besc] = acteur.value
      setFieldValue(field, acteur.value)

      currentActeurField.value = undefined
    }

    const fetchPaimentFret = async () => {
      try {
        const { data } = await ApiService.get("/type-fret-paiements")
        paiementFret.value = data.data.data.map((tf: any) => ({
          label: tf.libelle,
          value: tf.id
        }))
      } catch (err: any) {
        error(err.response?.data?.message || 'Erreur type fret')
      }
    }


    const fetchIncoterm = async () => {
      try {
        const { data } = await ApiService.get("/incoterms")
        incoterms.value = data.data.data.map((inco: any) => ({
          label: `${inco.code} - ${inco.libelle}`,
          value: inco.id
        }))
      } catch (err: any) {
        error(err.response?.data?.message || 'Erreur incoterms')
      }
    }


    const portsChargementFiltres = computed(() => {
      if (!form.paysOrigine) {
        return portsChargement.value
      }

      const paysSelectionne = paysAvecCodes.value.find(p => p.value === form.paysOrigine)
      if (!paysSelectionne) return portsChargement.value

      const portsFiltres = portsChargement.value.filter(port =>
        port.codePays === paysSelectionne.iso2_code || port.value === form.portChargement
      )

      console.log('portsChargementFiltres - Pays:', paysSelectionne.iso2_code, 'Ports:', portsFiltres.length)
      return portsFiltres
    })

    const portsDechargementFiltres = computed(() => {
      if (!form.destinationFinale) return []

      const paysSelectionne = paysAvecCodes.value.find(p => p.value === form.destinationFinale)
      if (!paysSelectionne) return portsDechargement.value

      return portsDechargement.value.filter(port =>
        port.codePays === paysSelectionne.iso2_code
      )
    })

    const onPaysOrigineChange = () => {
      form.portChargement = null
      setFieldValue('portChargement', null)
    }

    const onPaysDestinationChange = () => {
      form.portDechargement = null
      setFieldValue('portDechargement', null)
    }


    const searchPortChargement = async (query: string) => {

      if (searchTimeout) clearTimeout(searchTimeout)
      if (!query || query.length < 2 || !form.paysOrigine) {

        portsChargement.value = []
        return
      }

      const paysSelectionne = paysAvecCodes.value.find(p => p.value === form.paysOrigine)

      if (!paysSelectionne) {
        return
      }

      searchTimeout = setTimeout(async () => {
        loadingPorts.value = true
        try {
          const url = `/Liste/port?search=${encodeURIComponent(query)}&codePays=${paysSelectionne.iso2_code}`

          const response = await ApiService.get(url)
          console.log(' Réponse API:', response.data)

          const portsData = response.data?.data || []

          portsChargement.value = portsData.map((port: any) => ({
            label: `${port.nomPort} - ${port.locode}`,
            value: port.id,
            codePays: port.codePays,
            locode: port.locode
          }))

        } catch (err: any) {
          console.error(' Erreur recherche ports chargement:', err)
          error('Impossible de rechercher les ports de chargement')
          portsChargement.value = []
        } finally {
          loadingPorts.value = false
        }
      }, 300)
    }


    const searchPortDechargement = async (query: string) => {
      if (searchTimeout) clearTimeout(searchTimeout)
      if (!query || query.length < 2 || !form.destinationFinale) {
        portsDechargement.value = []
        return
      }

      const paysSelectionne = paysAvecCodes.value.find(p => p.value === form.destinationFinale)
      if (!paysSelectionne) return

      searchTimeout = setTimeout(async () => {
        loadingPorts.value = true
        try {
          const response = await ApiService.get(
            `/Liste/port?search=${encodeURIComponent(query)}&codePays=${paysSelectionne.iso2_code}`
          )
          const portsData = response.data?.data || []

          portsDechargement.value = portsData.map((port: any) => ({
            label: `${port.nomPort} - ${port.locode}`,
            value: port.id,
            codePays: port.codePays,
            locode: port.locode
          }))
        } catch (err: any) {
          console.error('Erreur recherche ports déchargement:', err)
          error('Impossible de rechercher les ports de déchargement')
          portsDechargement.value = []
        } finally {
          loadingPorts.value = false
        }
      }, 300)
    }

    const searchNavire = async (query: string, currentValue?: any) => {
      if (searchTimeout) {
        clearTimeout(searchTimeout)
      }

      if (!query || query.length < 2) {
        if (currentValue && navires.value.length > 0) {
          console.log('Navire déjà sélectionné, conservation de la liste')
          return
        }
        return
      }

      searchTimeout = setTimeout(async () => {
        loadingNavires.value = true

        try {
          const response = await ApiService.get(`/vessels?search=${encodeURIComponent(query)}`)
          const naviresData = response.data?.data || []

          navires.value = naviresData.map((navire: any) => ({
            label: `${navire.name} - ${navire.mmsi} - ${navire.imo}`,
            value: navire.id,
            imo: navire.imo
          }))

        } catch (err: any) {
          console.error('Erreur recherche navires:', err)
          error('Impossible de rechercher les navires')
          navires.value = []
        } finally {
          loadingNavires.value = false
        }
      }, 300)
    }

    

    const fetchPays = async () => {
      try {
        const { data } = await ApiService.get("/pays")

        pays.value = data.data.data.map((p: any) => ({
          label: p.name_fr,
          value: p.id
        }))

        paysAvecCodes.value = data.data.data.map((p: any) => ({
          label: p.name_fr,
          value: p.id,
          iso2_code: p.iso2_code
        }))

      } catch (err) {
        console.error('Erreur fetchPays:', err)
      }
    }

      const checkBlacklist = async (type, referenceValue) => {
        try {
          const response = await ApiService.get(
            `/regulatory/check?entry_type=${type}&reference_value=${referenceValue}`
          );
          return response.data.data;
        } catch (err) {
          console.error('Erreur vérification blacklist:', err);
          return { isBlacklisted: false, details: null };
        }
      };

      const fetchUsersTransitaires = async () => {
        loadingTransitaires.value = true
        try {
          const { data } = await ApiService.get('/users/by-role?role=Transitaire')
              console.log('Réponse transitaires:', data) 

          usersTransitaires.value = data.data.data.map((u: any) => ({
            label: `${u.prenom} ${u.nom}`,
            value: u.id
          }))
        } catch (err) {
          error('Erreur chargement transitaires')
        } finally {
          loadingTransitaires.value = false
        }
      }
      

    const saveStep1 = async (values: any) => {
      loading.value = true
      try {
        // Si l'utilisateur est transitaire, s'assurer que l'ID est bien présent
        if (isTransitaire.value && form.transitaire) {
          values.transitaire = form.transitaire
        }
        
        Object.assign(bescWizard.step1, values)
        console.log("Données à envoyer:", values);
        
        if (!bescWizard.bescId) {
          const res = await ApiService.post('/besc', values)
          console.log("Réponse création BESC:", res);
          bescWizard.bescId = res.data.data.id
        } else {
          await ApiService.put(
            `/besc/${bescWizard.bescId}`,
            values
          )
        }

        updateStepProgression('step1', true)

        router.push({
          name: 'AddBlStep2',
          params: { id: bescWizard.bescId }
        })

      } catch (err: any) {
        error(err.response?.data?.message || 'Erreur enregistrement BESC')
      } finally {
        loading.value = false
      }
    }

    onMounted(async () => {
      const idFromRoute = route.params.id as string | undefined
 await fetchPays()
  await fetchTypeActeurs()
  await fetchUsersTransitaires()
  await fetchActeurs()
  fetchPaimentFret()
  fetchIncoterm()

  console.log('getUserName:', JwtService.getUserName())
  console.log('getUserLastName:', JwtService.getUserLastName())
  console.log('getUserEmail:', JwtService.getUserEmail())

  //   if (isTransitaire.value && !idFromRoute) {
  //   const prenom = JwtService.getUserName() || ''
  //   const nom = JwtService.getUserLastName() || ''
  //   transitaireNom.value = `${prenom} ${nom}`.trim()
  //   console.log('✓ Transitaire:', transitaireNom.value)
  // }

  if (isTransitaire.value && !idFromRoute) {
  const prenom = JwtService.getUserName() || ''
  const nom = JwtService.getUserLastName() || ''
  const user = JwtService.getUser()
  
  transitaireNom.value = `${prenom} ${nom}`.trim()
  
  form.transitaire = user?.userId || ''
  setFieldValue('transitaire', user?.userId || '')
  
  console.log('✓ Transitaire nom:', transitaireNom.value)
  console.log('✓ Transitaire ID:', user?.userId)
}
  
      if (idFromRoute) {
        bescWizard.bescId = idFromRoute
        bescId.value = idFromRoute

        await loadBescProgressionFromAPI(idFromRoute)

        await fetchBescData(idFromRoute)
      } else if (bescWizard.bescId) {
        bescId.value = bescWizard.bescId
        await fetchBescData(bescWizard.bescId)
      } else {
        resetBescWizard()
      }
    })

    return {
      bescId,
      form,
      schema,
      loading,
      loadingBesc,
      loadingActeurs,
      today,
      transbordementOptions,
      incoterms,
      pays,
      paiementFret,
      navires,
      ports,
      saveStep1,
      loadNavireOption,
      setFieldValue,
      acteurs,
      showActeurModal,
      fetchActeurs,
      onActeurCreated,
      openActeurModal,
      currentActeurField,
      currentTypeActeurId,
      acteursParType,
      isEditMode,
      loadPortOption,
      showTransbordementFields,
      loadingNavires,
      searchNavire,
      loadingPorts,
      portsChargementFiltres,
      portsDechargementFiltres,
      onPaysOrigineChange,
      onPaysDestinationChange,
      searchPortChargement,
      vesselKey,
      searchPortDechargement,
      paysAvecCodes,
      portsChargement,
      portsDechargement,
      blacklistAlerts,
      checkBlacklist,
      isTransitaire,
      checkRole,
      usersTransitaires,
      loadingTransitaires,
      fetchUsersTransitaires,
      transitaireNom
    }
  }
})
</script>

<style scoped>
.section-title h5 {
  position: relative;
  padding-left: 15px;
}

.section-title h5::before {
  content: '';
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  width: 4px;
  height: 24px;
  background-color: #0a59a4;
  border-radius: 2px;
}

.modal.show {
  display: block !important;
}

.modal-backdrop {
  background-color: rgba(0, 0, 0, 0.5);
}

.btn-primary:hover,
.btn-primary:focus,
.btn-primary:active {
  background-color: #0a59a4 !important;
  border-color: #0a59a4 !important;
  color: #fff !important;
}
</style>
